var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M3,5H21V7H3V5M3,11V9H21V11H3M3,19V13H21V19H3Z"}})}
var staticRenderFns = []

export { render, staticRenderFns }